


export const getLiveViewersPlugin = (Clappr)=>{


//QualitySelector
 
return Clappr.UICorePlugin.extend({
  name: 'live_viewers',
  
  version: '1.0',

  
  bindEvents: function () {
 
      this.listenTo(this.core, Clappr.Events.CORE_ACTIVE_CONTAINER_CHANGED, this.reload);
      this.listenTo(this.core.mediaControl, Clappr.Events.MEDIACONTROL_RENDERED, this.render) 
  },

  unBindEvents: function () {
      var currentPlayback = this.core.activePlayback;

 
      this.stopListening(this.core, Clappr.Events.CORE_ACTIVE_CONTAINER_CHANGED);
      this.stopListening(this.core.mediaControl, Clappr.Events.MEDIACONTROL_RENDERED);
     
  },


shouldRender: function () {
      if (!this.core.activeContainer) return false;
var currentPlayback = this.core.activePlayback;
      if (!currentPlayback) return false;
	return true;
   
},

   reload: function () {
      this.unBindEvents();
      this.bindEvents();
 
  },
  render: function () {

	 
	 if (this.shouldRender()) {
         // this.$el.html(this.template());
	 this.core.mediaControl.$('.media-control-layer').parent().parent().append(this.el); //

	this.updateShowLiveView()
	}
	return this
     
  },

  template: function () {
	 

	var num = this.live_num
	var template = `    <div class="live-label">
                <div class="lbl live">
                <span>LIVE</span>
                </div>
                <div class="count-watchers">
                  <span class="live-viewers">${num}</span>
                  </div>
              </div>
`
	
return template

	
 
  },
  
  attributes: {
      'class': 'live_viewers',
      'data-live-viewers': ''
  },

  
  updateNumView: function(){
	

		var elem = this.$('.live-viewers')
		if(elem){
			elem.text(this.live_num)
		}
	},
 updateShowLiveView: function(){
		if(this.show_live){
 			this.$el.html(this.template());
		}else {
			this.$el.html('');
		}
		//this.$('.live-viewers').text(this.live_num)
	},
  setActualNum: function(num){
	this.live_num = num
	this.updateNumView()
	},
  
  setShowLive: function(show){
	this.show_live = show
	this.updateShowLiveView()
	},

 show_live: false,
 live_num: 0
});

//Object.defineProperty(QualitySelector, 'name', { value: 'QualitySelector' });

Clappr.Player.prototype.setLiveViewersVisibility = function (visible) {
  var liveViewers = this.getPlugin('live_viewers');
 
};
 

Clappr.Player.prototype.setLiveViewersNumber = function (num) {
  var liveViewers = this.getPlugin('live_viewers');
	
 	liveViewers.setActualNum(num)
};
 

}
